module.exports = {

    jobTrackerStatusCatalogue: () => [
        { label: "jobTrackerStatusSaved", code: "saved" },
        { label: "jobTrackerStatusApplied", code: "applied" },
        { label: "jobTrackerStatusInterview", code: "interview" },
        { label: "jobTrackerStatusOffer", code: "offer" }
    ],

    jobTrackerInterviewTypeCatalogue: () => [
        { label: "notSpecified", code: "" },
        { label: "jobTrackerInterviewTypePhone", code: "phone" },
        { label: "jobTrackerInterviewTypeVideo", code: "video" },
        { label: "jobTrackerInterviewTypeInPerson", code: "inPerson" }
    ]

}
